import statRoutes from './routes'

/* @ngInject */
const statRun = (
  $transitions,
) => {
  $transitions.onSuccess({
    entering: statRoutes.home.path,
  }, async (trans) => {

  })

  $transitions.onBefore({
    from: statRoutes.home.path,
  }, (trans) => {

  })
}

export default statRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/stat/stat.run.js